<template>
    <div class="vl-region vl-region--arrow">
        <div class="vl-layout">
            <h2 class="vl-title--h2">Hoe kan uw woning nog beter scoren?</h2>
            <div class="table-responsive">
                <table class="vl-data-table vl-data-table--lined table-custom">
                    <thead>
                    <tr>
                        <th></th>
                        <th>Uw huidige situatie</th>
                        <th>Hoe het energielabel verbeteren?</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th><strong>Mijn woning wordt verwarmd met</strong></th>
                        <td>
                            {{ currentSituation.verwarmingen.filter((v) => v.value ===
                            currentSituation.selectedVerwarming)[0].text }}
                        </td>
                        <td>
                            <label for="wk-c-verwarming" class="label-hidden">Mijn woning wordt verwarmd met</label>
                            <select name="wk-c-verwarming" id="wk-c-verwarming" class="vl-select vl-select--block"
                                    v-model="improvedSituation.selectedVerwarming" @change="updateVerwarmingDetails">
                                <option value="" disabled>Maak een keuze</option>
                                <template v-for="verwarming in improvedSituation.verwarmingen">
                                    <option :value="verwarming.value" :key="verwarming.value"
                                            :selected="verwarming.value === currentSituation.selectedVerwarming">
                                        {{ verwarming.text }}
                                    </option>
                                </template>
                            </select>
                        </td>
                    </tr>
                    <tr v-if="improvedSituation.selectedVerwarming !== 'Warmtenet'">
                        <th><strong>Mijn verwarming is</strong></th>
                        <td>
                            <template v-if="currentSituation.selectedVerwarmingDetail">
                                {{ currentSituation.verwarmingDetails.filter((v) => v.value ===
                                currentSituation.selectedVerwarmingDetail)[0].text }}
                            </template>
                            <template v-else>
                                nvt
                            </template>
                        </td>
                        <td>
                            <label for="wk-c-verwarming-detail" class="label-hidden">Mijn verwarming is</label>
                            <select name="wk-c-verwarming-detail" id="wk-c-verwarming-detail"
                                    class="vl-select vl-select--block"
                                    v-model="improvedSituation.selectedVerwarmingDetail"
                                    @change="updateSanitairWarmWaters">
                                <option value="" disabled>Maak een keuze</option>
                                <template v-for="verwarmingDetail in improvedSituation.verwarmingDetails">
                                    <option :value="verwarmingDetail.value" :key="verwarmingDetail.value"
                                            :selected="verwarmingDetail.value === currentSituation.selectedVerwarmingDetail">
                                        {{ verwarmingDetail.text }}
                                    </option>
                                </template>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th><strong>Sanitair warm water</strong></th>
                        <td>
                            {{ currentSituation.sanitairWarmWaters.filter((v) => v.value ===
                            this.currentSituation.selectedSanitairWarmWater)[0].text }}
                        </td>
                        <td>
                            <label for="wk-c-sanitair-warm-water" class="label-hidden">Sanitair warm water</label>
                            <select name="wk-c-sanitair-warm-water" id="wk-c-sanitair-warm-water"
                                    class="vl-select vl-select--block"
                                    v-model="improvedSituation.selectedSanitairWarmWater"
                                    @change="calculateNewEpcLabel">
                                <option value="" disabled>Maak een keuze</option>
                                <template v-for="sanitairWarmWater in improvedSituation.sanitairWarmWaters">
                                    <option :value="sanitairWarmWater.value" :key="sanitairWarmWater.value"
                                            :selected="sanitairWarmWater.value === currentSituation.selectedSanitairWarmWater">
                                        {{ sanitairWarmWater.text }}
                                    </option>
                                </template>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th><strong>Hernieuwbare systemen</strong></th>
                        <td>
                            <div v-if="!currentSituation.zonneboilerCheck && !currentSituation.PVInstallatieCheck">
                                U hebt geen hernieuwbare systemen opgegeven.
                            </div>
                            <ul class="list-separated">
                                <li v-if="currentSituation.zonneboilerCheck">Zonneboiler</li>
                                <li v-if="currentSituation.PVInstallatieCheck">Zonnepanelen</li>
                            </ul>
                        </td>
                        <td>
                            <div class="vl-u-spacer--xsmall" v-if="!currentSituation.zonneboilerCheck">
                                <label for="wk-c-zonneboiler" class="vl-checkbox">
                                    <input type="checkbox" name="wk-c-zonneboiler" id="wk-c-zonneboiler"
                                           class="vl-checkbox__toggle" v-model="improvedSituation.zonneboilerCheck"
                                           @change="calculateNewEpcLabel"/>
                                    <span class="vl-checkbox__label">
                                        <i class="vl-checkbox__box" aria-hidden="true"></i>Zonneboiler
                                    </span>
                                </label>
                            </div>
                            <div class="vl-u-spacer--xsmall" v-if="!currentSituation.PVInstallatieCheck">
                                <label for="wk-c-pv-installatie" class="vl-checkbox">
                                    <input type="checkbox" name="wk-c-pv-installatie" id="wk-c-pv-installatie"
                                           class="vl-checkbox__toggle" v-model="improvedSituation.PVInstallatieCheck"
                                           @change="calculateNewEpcLabel"/>
                                    <span class="vl-checkbox__label">
                                        <i class="vl-checkbox__box" aria-hidden="true"></i>Zonnepanelen
                                    </span>
                                </label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th><strong>Ventilatie</strong></th>
                        <td>
                            {{ currentSituation.ventilaties.filter((v) => v.value ===
                            currentSituation.selectedVentilatie)[0].text }}
                        </td>
                        <td>
                            <label for="wk-c-ventilatie" class="label-hidden">Ventilatie</label>
                            <select name="wk-c-ventilatie" id="wk-c-ventilatie" class="vl-select vl-select--block"
                                    v-model="improvedSituation.selectedVentilatie" @change="calculateNewEpcLabel">
                                <template v-for="ventilatie in improvedSituation.ventilaties">
                                    <option :value="ventilatie.value" :key="ventilatie.value"
                                            :selected="ventilatie.value === currentSituation.selectedVentilatie">
                                        {{ ventilatie.text }}
                                    </option>
                                </template>
                            </select>
                        </td>
                    </tr>
                    <template v-if="improvedSituation.bebouwing !== 'appartement'
                                        || (improvedSituation.bebouwing === 'appartement' && improvedSituation.selectedAppartementType === 'AppartementDak')">
                        <tr v-if="improvedSituation.daktype === 'Dak_hellend' || improvedSituation.daktype === 'Gemengd'">
                            <th><strong>Hellend dak</strong></th>
                            <td>
                                {{ currentSituation.hellendeDaken.filter((v) => v.value ===
                                currentSituation.selectedHellendDak)[0].text }}
                            </td>
                            <td>
                                <label for="wk-c-hellend-dak" class="label-hidden">Hellend dak</label>
                                <select name="wk-c-hellend-dak" id="wk-c-hellend-dak" class="vl-select vl-select--block"
                                        v-model="improvedSituation.selectedHellendDak" @change="calculateNewEpcLabel">
                                    <template v-for="hellendDak in improvedSituation.hellendeDaken">
                                        <option :value="hellendDak.value" :key="hellendDak.value"
                                                :selected="hellendDak.value === currentSituation.selectedHellendDak">
                                            {{ hellendDak.text }}
                                        </option>
                                    </template>
                                </select>
                            </td>
                        </tr>
                        <tr v-if="improvedSituation.daktype === 'Dak_plat' || improvedSituation.daktype === 'Gemengd'">
                            <th><strong>Plat dak</strong></th>
                            <td>
                                {{ currentSituation.platteDaken.filter((v) => v.value ===
                                currentSituation.selectedPlatDak)[0].text }}
                            </td>
                            <td>
                                <label for="wk-c-plat-dak" class="label-hidden">Plat dak</label>
                                <select name="wk-c-plat-dak" id="wk-c-plat-dak" class="vl-select vl-select--block"
                                        v-model="improvedSituation.selectedPlatDak" @change="calculateNewEpcLabel">
                                    <template v-for="platDak in improvedSituation.platteDaken">
                                        <option :value="platDak.value" :key="platDak.value"
                                                :selected="platDak.value === currentSituation.selectedPlatDak">
                                            {{ platDak.text }}
                                        </option>
                                    </template>
                                </select>
                            </td>
                        </tr>
                    </template>
                    <template v-if="improvedSituation.bebouwing !== 'appartement'">
                        <tr v-if="improvedSituation.vloertype === 'VolleGrond' || improvedSituation.vloertype === 'Gemengd'">
                            <th><strong>Vloer op volle grond</strong></th>
                            <td>
                                {{ currentSituation.vloerenVolleGrond.filter((v) => v.value ===
                                currentSituation.selectedVloerVolleGrond)[0].text }}
                            </td>
                            <td>
                                <label for="wk-c-volle-grond" class="label-hidden">Vloer op volle grond</label>
                                <select name="wk-c-volle-grond" id="wk-c-volle-grond" class="vl-select vl-select--block"
                                        v-model="improvedSituation.selectedVloerVolleGrond"
                                        @change="calculateNewEpcLabel">
                                    <template v-for="vloer in improvedSituation.vloerenVolleGrond">
                                        <option :value="vloer.value" :key="vloer.value"
                                                :selected="vloer.value === currentSituation.selectedVloerVolleGrond">
                                            {{ vloer.text }}
                                        </option>
                                    </template>
                                </select>
                            </td>
                        </tr>
                        <tr v-if="improvedSituation.vloertype === 'BovenKelder' || improvedSituation.vloertype === 'Gemengd'">
                            <th><strong>Vloer boven kelder</strong></th>
                            <td>
                                {{ currentSituation.vloerenBovenKelder.filter((v) => v.value ===
                                currentSituation.selectedVloerBovenKelder)[0].text }}
                            </td>
                            <td>
                                <label for="wk-c-boven-kelder" class="label-hidden">Vloer boven kelder</label>
                                <select name="wk-c-boven-kelder" id="wk-c-boven-kelder"
                                        class="vl-select vl-select--block"
                                        v-model="improvedSituation.selectedVloerBovenKelder"
                                        @change="calculateNewEpcLabel">
                                    <template v-for="vloer in improvedSituation.vloerenBovenKelder">
                                        <option :value="vloer.value" :key="vloer.value"
                                                :selected="vloer.value === currentSituation.selectedVloerBovenKelder">
                                            {{ vloer.text }}
                                        </option>
                                    </template>
                                </select>
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <th><strong>Buitenmuur</strong></th>
                        <td>
                            {{ currentSituation.buitenmuren.filter((v) => v.value ===
                            currentSituation.selectedBuitenmuur)[0].text }}
                        </td>
                        <td>
                            <label for="wk-c-buitenmuur" class="label-hidden">Buitenmuur</label>
                            <select name="wk-c-buitenmuur" id="wk-c-buitenmuur" class="vl-select vl-select--block"
                                    v-model="improvedSituation.selectedBuitenmuur" @change="calculateNewEpcLabel">
                                <template v-for="buitenmuur in improvedSituation.buitenmuren">
                                    <option :value="buitenmuur.value" :key="buitenmuur.value"
                                            :selected="buitenmuur.value === currentSituation.selectedBuitenmuur">
                                        {{ buitenmuur.text }}
                                    </option>
                                </template>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th><strong>Beglazing vensters</strong></th>
                        <td>
                            {{ currentSituation.vensters.filter((v) => v.value ===
                            currentSituation.selectedVenster)[0].text }}
                        </td>
                        <td>
                            <label for="wk-c-vensters" class="label-hidden">Beglazing vensters</label>
                            <select name="wk-c-vensters" id="wk-c-vensters" class="vl-select vl-select--block"
                                    v-model="improvedSituation.selectedVenster" @change="calculateNewEpcLabel">
                                <template v-for="venster in improvedSituation.vensters">
                                    <option :value="venster.value" :key="venster.value"
                                            :selected="venster.value === currentSituation.selectedVenster">
                                        {{ venster.text }}
                                    </option>
                                </template>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th><strong>Uw indicatief energielabel</strong></th>
                        <td>
                            <span class="e-label e-label--small float-left mr-5"
                                  :class="epcLabelClass(calculatedEpc.label)">{{ calculatedEpc.label }}</span>
                            <span class="e-label-usage">
                                <kwh :label="calculatedEpc.label"/>
                            </span>
                        </td>
                        <td>
                            <b-spinner v-if="loading" label="Laden..."></b-spinner>
                            <div v-if="improvedCalculatedEpc.label && !loading">
                                <span class="e-label e-label--small float-left mr-5"
                                      :class="epcLabelClass(improvedCalculatedEpc.label)">{{ improvedCalculatedEpc.label }}</span>
                                <span class="e-label-usage">
                                    <kwh :label="improvedCalculatedEpc.label"/>
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th><strong>Uw indicatieve energiescore</strong></th>
                        <td>~ {{ (calculatedEpc.epcScore/10).toFixed(0) * 10 }} kWh/(m² jaar)</td>
                        <td>
                            <b-spinner v-if="loading" label="Laden..."></b-spinner>
                            <div v-if="improvedCalculatedEpc.label && !loading">
                                ~ {{ (improvedCalculatedEpc.epcScore/10).toFixed(0) * 10 }} kWh/(m² jaar)
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3">
                            Bovenstaande resultaten zijn slechts een indicatie en kunnen afwijken van uw eigen situatie. 
                            Lees hiervoor de                                     
                            <span class="vl-u-text--bold">disclaimer</span>
                            <span id="tooltip-disclaimer" class="vl-icon vl-vi vl-vi-info-filled"></span>
                            .
                            <b-tooltip target="tooltip-disclaimer" triggers="hover" customClass="vl-tooltip">
                                <p class="vl-u-text--italic">
                                    <span class="vl-u-text--bold">Disclaimer</span><br>
                                    {{calculatedEpc.disclaimer}}
                                </p>
                            </b-tooltip>
                            <br><br>
                            Wilt u de impact van  verbeteringen op uw eigen energielabel te weten komen?
                            Laat een EPC opmaken door een erkend energiedeskundige type A via deze 
                            <a href="https://www.energiesparen.be/epcparticulier" target="_blank">link</a>.                           
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import Kwh from '@/components/partials/Kwh'
    import Vue from 'vue';
    import HttpService from "@/services/HttpService";

    export default {
        name: 'beterScoren',
        props: ['currentSituationProp', 'calculatedEpc'],
        components: {Kwh},
        data: function () {
            return {
                loading: false,
                improvedCalculatedEpc: {
                    label: null,
                    epcScore: null,
                },
                currentSituation: Vue.util.extend({}, this.currentSituationProp),
                improvedSituation: {
                    bebouwing: this.currentSituationProp.bebouwing,
                    selectedOppervlakte: this.currentSituationProp.selectedOppervlakte,
                    selectedAppartementType: this.currentSituationProp.selectedAppartementType,
                    appartementTypes: this.currentSituationProp.appartementTypes,
                    selectedVerwarming: this.currentSituationProp.selectedVerwarming,
                    verwarmingen: this.currentSituationProp.verwarmingen,
                    selectedVerwarmingDetail: this.currentSituationProp.selectedVerwarmingDetail,
                    verwarmingDetails: this.currentSituationProp.verwarmingDetails,
                    selectedSanitairWarmWater: this.currentSituationProp.selectedSanitairWarmWater,
                    sanitairWarmWaters: this.currentSituationProp.sanitairWarmWaters,
                    zonneboilerCheck: this.currentSituationProp.zonneboilerCheck,
                    PVInstallatieCheck: this.currentSituationProp.PVInstallatieCheck,
                    selectedVentilatie: this.currentSituationProp.selectedVentilatie,
                    ventilaties: this.currentSituationProp.ventilaties,
                    daktype: this.currentSituationProp.daktype,
                    selectedHellendDak: this.currentSituationProp.selectedHellendDak,
                    hellendeDaken: this.currentSituationProp.hellendeDaken,
                    selectedPlatDak: this.currentSituationProp.selectedPlatDak,
                    platteDaken: this.currentSituationProp.platteDaken,
                    vloertype: this.currentSituationProp.vloertype,
                    selectedVloerVolleGrond: this.currentSituationProp.selectedVloerVolleGrond,
                    vloerenVolleGrond: this.currentSituationProp.vloerenVolleGrond,
                    selectedVloerBovenKelder: this.currentSituationProp.selectedVloerBovenKelder,
                    vloerenBovenKelder: this.currentSituationProp.vloerenBovenKelder,
                    selectedBuitenmuur: this.currentSituationProp.selectedBuitenmuur,
                    buitenmuren: this.currentSituationProp.buitenmuren,
                    selectedVenster: this.currentSituationProp.selectedVenster,
                    vensters: this.currentSituationProp.vensters,
                },
              httpService: new HttpService(),
            }
        },
      provide(){
        return {httpService: this.httpService}
      },
        methods: {
            epcLabelClass(label) {
                return {
                    'e-label--a-plus': label === 'A+',
                    'e-label--a': label === 'A',
                    'e-label--b': label === 'B',
                    'e-label--c': label === 'C',
                    'e-label--d': label === 'D',
                    'e-label--e': label === 'E',
                    'e-label--f': label === 'F'
                }
            },
            calculateNewEpcLabel() {
                if ((this.improvedSituation.selectedVerwarming === 'Warmtenet' && this.improvedSituation.selectedSanitairWarmWater) ||
                    (this.improvedSituation.selectedVerwarming && this.improvedSituation.selectedVerwarmingDetail && this.improvedSituation.selectedSanitairWarmWater)) {
                    const loading = this.$loading({lock: true});
                    this.loading = true;
                    let result = new Promise((resolve) => this.$emit('improvedSituationChanged', this.improvedSituation, resolve));
                    result.then(data => {
                      this.httpService.postBerekenIndicatief(data).then(resp => {
                        this.improvedCalculatedEpc.label = resp.data.label;
                        this.improvedCalculatedEpc.epcScore = resp.data.primairEnergieverbruikPerM2;
                        this.loading = false;
                        loading.close();
                      }).catch(() => {
                        this.$emit('axiosError');
                        this.loading = false;
                        loading.close();
                      });
                  });
                }
            },
            updateVerwarmingDetails() {

              switch (this.improvedSituation.selectedVerwarming) {
                case 'Elektriciteit':
                  this.improvedSituation.verwarmingDetails = [
                    {text: 'Elektrische verwarming (direct/accumulatie)', value: 'elektrische weerstandsverwarming'},
                    {text: 'Warmtepomp lucht/lucht', value: 'elektrische warmtepomp lucht-lucht'},
                    {text: 'Warmtepomp lucht/water', value: 'elektrische warmtepomp lucht-water'},
                    {text: 'Warmtepomp bodem/water', value: 'elektrische warmtepomp bodem-water'},
                  ];
                  break;
                case 'Gas':
                  this.improvedSituation.verwarmingDetails = [
                    {text: 'Hybride warmtepomp', value: 'hybride warmtepomp'},
                    {text: 'Condenserende ketel', value: 'condenserende ketel'},
                    {text: 'Niet-condenserende ketel', value: 'niet-condenserende ketel'},
                    {text: 'Kachel(s)', value: 'kachel'},
                  ];
                  break;
                case 'Stookolie':
                  this.improvedSituation.verwarmingDetails = [
                    {text: 'Hybride warmtepomp', value: 'hybride warmtepomp'},
                    {text: 'Condenserende ketel', value: 'condenserende ketel'},
                    {text: 'Niet-condenserende ketel', value: 'niet-condenserende ketel'},
                    {text: 'Kachel(s)', value: 'kachel'},
                  ];
                  break;
                default:
                  this.improvedSituation.verwarmingDetails = [
                    {text: 'Condenserende ketel', value: 'condenserende ketel'},
                    {text: 'Niet-condenserende ketel', value: 'niet-condenserende ketel'},
                    {text: 'Kachel(s)', value: 'kachel'},
                  ];
                  break;
              }
                this.improvedSituation.selectedVerwarmingDetail = '';
                this.updateSanitairWarmWaters();
            },
            updateSanitairWarmWaters() {
                this.improvedSituation.sanitairWarmWaters = this.improvedSituation.sanitairWarmWaters.filter(function (sanitairWarmWater) {
                    return sanitairWarmWater.value !== 'zelfde toestel als ruimteverwarming';
                });
                if (this.improvedSituation.selectedVerwarmingDetail !== 'kachel' &&
                    this.improvedSituation.selectedVerwarmingDetail !== 'elektrische weerstandsverwarming' &&
                    this.improvedSituation.selectedVerwarmingDetail !== 'elektrische warmtepomp lucht-lucht') {
                    this.improvedSituation.sanitairWarmWaters.unshift({
                            text: 'Zelfde toestel als ruimteverwarming',
                            value: 'zelfde toestel als ruimteverwarming'
                        },
                    );
                }
                this.improvedSituation.selectedSanitairWarmWater = '';
            },
        },
    }
</script>
